import { ViewModes } from '../../constants/view-modes';
const getBasicParams = (state) => state.baseParams;
export const getViewMode = (state) => getBasicParams(state).viewMode;
export const getInstance = (state) => getBasicParams(state).instance;
export const getInstanceValues = (state) => getBasicParams(state).instanceValues;
export const getLanguage = (state) => getBasicParams(state).language || 'en';
export const getIsSSR = (state) => getBasicParams(state).isSSR;
export const isDebug = (state) => getBasicParams(state).isDebug;
export const getAppDefinitionId = (state) => getBasicParams(state).appDefinitionId;
export const getIsMaInstalled = (state) => getBasicParams(state).isMaInstalled;
export const getIsChatInstalled = (state) => getBasicParams(state).isChatInstalled;
export const getIsRtl = (state) => getBasicParams(state).isRTL;
export const getIsEditor = (state) => getViewMode(state) === ViewModes.Editor;
export const getIsPreview = (state) => getViewMode(state) === ViewModes.Preview;
export const isSeo = (state) => getBasicParams(state).isSeo;
export const getIsMobile = (state) => getBasicParams(state).formFactor === 'Mobile';
export const getMetaSiteId = (state) => getInstanceValues(state).metaSiteId;
export const isLoggingEnabled = (state) => isDebug(state);
//# sourceMappingURL=base-params-selectors.js.map